export const conocimientosTranslations = {
  es: {
    title: "Conocimientos",
    subtitle: "Mi formación académica y profesional",
    description: "Estos son los procesos de apredizaje que he realizado y los conocimientos que he adquirido gracias a ellos. Siempre estoy en constante evolución y aprendizaje lo cual habla mucho de mi forma de ser y de por qué me gusta el mundo IT.",
    facultad: {
      title: "Facultad",
      description: "Estudio en la Facultad de Ingeniería de la ORT, curso Ingeniería en Sistemas."
    },
    jap: {
      title: "Jóvenes a Programar",
      description: "JaP es un curso brindado por Ceibal (Conectividad Educativa de Informática Básica para el Aprendizaje en Línea). Lo hice en 2024, la primer mitad del año la Fase 1, aprendiendo los básicos de programación, y luego la otra mitad del año hasta diciembre, la Fase 2, aprendiendo desarrollo web y realizando un proyecto grupal de e-commerce."
    },
    coursera: {
      title: "Coursera",
      description: "Como parte del intensivo de verano y nivel 2 de JaP, completé especializaciones de IBM en Coursera: IBM Full Stack Software Developer, IBM Data Science Specialization e IBM Data Engineering Foundations. También obtuve el certificado de Scrum Master de LearnQuest."
    },
    googlecloud: {
      title: "Google Cloud",
      description: "Como parte de mi formación en una empresa partner de Google, aprendí con la formación Professional Data Engineer y con el curso de Agentspace \"Extend Agentspace assistant capabilities\"."
    },    certificates: {
      title: "Certificados",
      description: "Estos son los documentos de los certificados de los distintos cursos, incluyendo el FCE B2 de inglés de cambridge.",
      button: "Ver Certificados"
    },    technologies: {
      title: "Tecnologías",
      button: "Ver Tecnologías",
      tags: [
        "JavaScript", "React", "Node.js", "Python", "Java", "HTML", "CSS", 
        "Tailwind CSS", "Git", "GitHub", "SQL", "PostgreSQL", "MongoDB", 
        "Express", "Bootstrap", "Figma", "VS Code", "Scrum", "Linux", 
        "Docker", "AWS", "REST APIs", "JSON", "TypeScript", "Redux"
      ]
    }
  },
  en: {
    title: "Knowledge",
    subtitle: "My academic and professional training",
    description: "These are the learning processes I’ve gone through and the knowledge I’ve gained from them. I’m always evolving and learning, which says a lot about who I am and why I’m passionate about the IT world.",
    facultad: {
      title: "University",
      description: "I study at the Facultad de ingeniería in ORT University, doing a degree in software Engineering."
    },
    jap: {
      title: "Jóvenes a Programar",
      description: "JaP is a course offered by Ceibal (Educational Connectivity and Basic Computing for Online Learning). I took it in 2024. During the first half of the year I completed Phase 1, learning the basics of programming, and during the second half until December, I completed Phase 2, focusing on web development and working on a group e-commerce project "

    },
    coursera: {
      title: "Coursera",
      description: "As part of the JaP summer intensive and Level 2, I completed IBM specializations on Coursera: IBM Full Stack Software Developer, IBM Data Science Specialization, and IBM Data Engineering Foundations. I also earned the Scrum Master certificate from LearnQuest."
    },
    googlecloud: {
      title: "Google Cloud",
      description: "As part of my training at a Google partner company, I completed the Professional Data Engineer certification and the Agentspace course \"Extend Agentspace assistant capabilities\"."
    },    certificates: {
      title: "Certificates",
      description: "",
      button: "View Certificates"
    },    technologies: {
      title: "Technologies",
      button: "View Technologies",
      tags: [
        "JavaScript", "React", "Node.js", "Python", "Java", "HTML", "CSS", 
        "Tailwind CSS", "Git", "GitHub", "SQL", "PostgreSQL", "MongoDB", 
        "Express", "Bootstrap", "Figma", "VS Code", "Scrum", "Linux", 
        "Docker", "AWS", "REST APIs", "JSON", "TypeScript", "Redux"
      ]
    }
  }
};
